<template>
    <th class="bg-slate5/10 px4 py1.5">
        <slot />
    </th>
</template>
